import * as React from 'react';

export default class MasterCardIcon extends React.Component {
  render() {
    return React.createElement('svg', {
      className: this.props.className,
      viewBox: '0 0 28 21',
      dangerouslySetInnerHTML: {
        __html:
          '<path fill="#ff0016" d="M13.3,13.5h1.4c0.2-0.4,0.4-0.8,0.5-1.2h-2.4c-0.1-0.4-0.2-0.8-0.3-1.2h2.9c0-0.2,0-0.4,0-0.6c0-0.2,0-0.3,0-0.5c0,0,0-0.1,0-0.1h-2.9c0-0.4,0.1-0.8,0.3-1.2h2.4c-0.1-0.4-0.3-0.8-0.5-1.2h-1.4c0.2-0.3,0.4-0.7,0.7-1c0,0,0,0,0,0c-1.1-1.3-2.7-2.1-4.5-2.1c-3.3,0-6,2.7-6,6c0,3.3,2.7,6,6,6c1.8,0,3.5-0.8,4.6-2.1c0,0,0,0,0,0C13.7,14.1,13.5,13.8,13.3,13.5z"/><path fill="#ffa916" d="M18.5,4.6c-1.8,0-3.4,0.8-4.5,2c0,0,0,0,0,0c-0.3,0.3-0.5,0.6-0.7,1h1.4c0.2,0.4,0.4,0.8,0.5,1.2h-2.4c-0.1,0.4-0.2,0.8-0.3,1.2h2.9c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0,0.5c0,0.2,0,0.4,0,0.6h0h-2.9c0,0.4,0.1,0.8,0.3,1.2h2.4c-0.1,0.4-0.3,0.8-0.5,1.2h-1.4c0.2,0.3,0.4,0.7,0.7,0.9c0,0,0,0,0,0c1.1,1.2,2.7,2,4.5,2c3.3,0,6-2.7,6-5.9C24.5,7.2,21.8,4.6,18.5,4.6z"/><path fill="#192169" d="M24.5,0h-21C1.6,0,0,1.6,0,3.5v14C0,19.4,1.6,21,3.5,21h21c1.9,0,3.5-1.6,3.5-3.5v-14C28,1.6,26.4,0,24.5,0zM27,17.5c0,1.4-1.1,2.5-2.5,2.5h-21C2.1,20,1,18.9,1,17.5v-14C1,2.1,2.1,1,3.5,1h21C25.9,1,27,2.1,27,3.5V17.5z"/>',
      },
    });
  }
}
